// @flow

export {Carousel, Carousel as default, CAROUSEL_MOVE_DIRECTION, CAROUSEL_POSITION} from './carousel.component';
export {CarouselItem} from './carousel-item';
export type {
    ChangeDataType,
    AfterChange,
    OnDragStop,
    MoveDirectionType,
    CarouselPosition,
    ChangeParamsType
} from './typedef';

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./carousel.component");

require("./typedef");

require("./carousel-item");
